import {createContext, useContext} from "react";

type AppContextType = {
  isMobile: boolean;
};

export const AppContext = createContext<AppContextType>({
  isMobile: false,
});

export const useAppContext = () => useContext(AppContext);